module.exports = __webpack_public_path__ + "img/Categories_bg_03.bdadc6d0.jpg";